import * as React from "react";
import uniqueId from "lodash/uniqueId";
import styled from "@emotion/styled";
import { IconChevron } from "./icons";

type ExpandContentButtonProps = {
  showLabel: React.ReactNode;
  hideLabel?: React.ReactNode;
  chevron?: boolean;
  children: React.ReactNode;
};

function ExpandContent({
  showLabel,
  hideLabel,
  chevron = true,
  children,
  ...props
}: ExpandContentButtonProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const hideLabelNew = hideLabel || showLabel;
  const [id] = React.useState(uniqueId());

  return (
    <ExpandContentWrapper {...props}>
      <ExpandContentText id={id} isOpen={!isOpen}>
        {children}
      </ExpandContentText>
      <ExpandContentButton
        onClick={toggle}
        isOpen={isOpen}
        aria-controls={id}
        aria-label={isOpen ? "Collapse content" : "Expand content"}
        aria-expanded={isOpen ? "true" : "false"}
      >
        {chevron && <IconChevron className="chevron" />}{" "}
        {isOpen ? hideLabelNew : showLabel}
      </ExpandContentButton>
    </ExpandContentWrapper>
  );
}
const ExpandContentWrapper = styled.div({
  position: "relative",
  marginBottom: 5,
});
const ExpandContentButton = styled.button<{ isOpen: boolean }>(
  ({ isOpen, theme }) => ({
    backgroundColor: "transparent",
    border: 0,
    borderRadius: 0,
    cursor: "pointer",
    fontSize: theme.fontSizes.xxxs,
    opacity: ".66",
    padding: 0,
    ".chevron": {
      transform: isOpen ? "rotate(0)" : "rotate(180deg) translateY(-2px)",
    },
  })
);
const ExpandContentText = styled.div<{ isOpen: boolean }>(
  ({ isOpen, theme }) => ({
    maxHeight: isOpen ? "3.1em" : "none",
    overflow: "hidden",
    position: "relative",
    textOverflow: "ellipsis",
    "&::after": {
      content: "''",
      position: "absolute",
      lineHeight: 1.4,
      left: 0,
      right: 0,
      bottom: 0,
      height: "1.5em",
      backgroundImage: isOpen
        ? "linear-gradient(0deg, white 0%, transparent 100%)"
        : "none",
    },
  })
);
export { ExpandContent };
